import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Form, InputGroup } from 'react-bootstrap';
import { FiPlus, FiSearch, FiEye, FiEdit2, FiMapPin } from 'react-icons/fi';
import Card from '../Components/Card';
import DataTable from '../Components/DataTable';
import { useRetailerList } from '../hooks/useRetailers';

const columns = [
  { key: 'customerCode', header: 'Code', width: 120 },
  { key: 'customerName', header: 'Retailer' },
  { key: 'mobileNumber', header: 'Mobile', width: 130 },
  { key: 'cityName', header: 'City', width: 140 },
  { key: 'regionName', header: 'State', width: 140 },
  { key: 'pincode', header: 'Pincode', width: 100 },
  { key: 'gstin', header: 'GSTIN', width: 160, render: (r) => r.gstin || <span className="hrms-muted">—</span> },
];

export default function RetailersListPage() {
  const navigate = useNavigate();
  const [term, setTerm] = useState('');
  const [search, setSearch] = useState('');
  const { data: rows, isLoading, isError, error } = useRetailerList(search || undefined);

  const submitSearch = (e) => { e.preventDefault(); setSearch(term.trim()); };

  return (
    <div className="hrms-page">
      <div className="hrms-toolbar">
        <h1 className="hrms-page-title">Retailers</h1>
        <div className="d-flex gap-2">
          <Button variant="light" onClick={() => navigate('/retailers/drafts')}>Drafts</Button>
          <Button className="hrms-btn-primary" onClick={() => navigate('/retailers/new')}>
            <FiPlus className="me-1" /> Create new
          </Button>
        </div>
      </div>

      <Card>
        <Form onSubmit={submitSearch} className="mb-3" style={{ maxWidth: 360 }}>
          <InputGroup>
            <Form.Control
              placeholder="Search code or name…"
              value={term}
              onChange={(e) => setTerm(e.target.value)}
            />
            <Button variant="light" type="submit"><FiSearch /></Button>
          </InputGroup>
        </Form>

        {isError ? (
          <div className="hrms-field-error">{error?.friendlyMessage || 'Failed to load retailers.'}</div>
        ) : (
          <DataTable
            columns={columns}
            rows={rows}
            loading={isLoading}
            rowKey="cmGuid"
            emptyMessage="No retailers for your stations yet. Click “Create new”."
            massActions={[
              { label: 'Export (coming soon)', onClick: () => {} },
            ]}
            rowActions={(row) => (
              <>
                <Button size="sm" variant="light" title="View" onClick={() => navigate(`/retailers/${row.cmGuid}`)}><FiEye /></Button>
                <Button size="sm" variant="light" title="Edit" onClick={() => navigate(`/retailers/${row.cmGuid}/edit`)}><FiEdit2 /></Button>
                <Button size="sm" variant="light" title="Check-in" onClick={() => navigate(`/retailers/${row.cmGuid}/checkin`)}><FiMapPin /></Button>
              </>
            )}
          />
        )}
      </Card>
    </div>
  );
}
